import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      return;
    }

    const targetHash = hash.startsWith("#") ? hash : `#${hash}`;
    let attempts = 0;
    const maxAttempts = 10;

    const scrollToTarget = () => {
      const element = document.querySelector(targetHash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(scrollToTarget, 100);
      }
    };

    setTimeout(scrollToTarget, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
